import PropTypes from "prop-types"
import React, { useEffect, useCallback } from "react"

import { connect } from "react-redux"

import { Link } from "react-router-dom"
import "./Header.scss"




import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

// import megamenuImg from "../../assets/images/megamenu-img.png"

import PixwikFold from "../../assets/pixwik/logo-fold.png"
import PixwikLogo from "../../assets/pixwik/logo.png"
import { changeMode } from "../../store/actions"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

const Header = props => {
  const applyTheme = useCallback((mode) => {
    props.changeMode(mode)
    document.body.setAttribute("data-theme-mode", mode)
    
    if (mode === "dark") {
      document.body.classList.add("dark-mode")
    } else {
      document.body.classList.remove("dark-mode")
    }
  }, [props.changeMode])

  useEffect(() => {
    const savedMode = localStorage.getItem("theme-mode") || "light"
    const checkbox = document.getElementById("mode-toggle")
    if (checkbox) {
      checkbox.checked = savedMode === "dark"
    }

    applyTheme(savedMode)
  }, [applyTheme])




  

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT,
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")
  }
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={PixwikFold} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={PixwikLogo} alt="" height="19" />
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={PixwikFold} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={PixwikLogo} alt="" height="19" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-24 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <i className="mdi mdi-menu"></i>
            </button>
            {/* <div className="d-none d-sm-block">
              <Dropdown
                isOpen={createmenu}
                toggle={() => setCreateMenu(!createmenu)}
                className="d-inline-block"
              >
                <div className="dropdown dropdown-topbar pt-3 mt-1 d-inline-block">
                  <DropdownToggle className="btn btn-light" tag="button">
                    Add <i className="mdi mdi-chevron-down"></i>
                  </DropdownToggle>

                  <DropdownMenu className="dropdown-menu-end">
                    <Link to="/addUniversity">
                      <DropdownItem>University</DropdownItem>
                    </Link>

                    <Link to="/addInstituion">
                      <DropdownItem>Institution</DropdownItem>
                    </Link>
                    <Link to="/add-category">
                      <DropdownItem>Category</DropdownItem>
                    </Link>
                    <Link to="/addProgram">
                      <DropdownItem tag="a" href="#">
                        Program
                      </DropdownItem>
                    </Link>
                    <Link to="/addCourse">
                      <DropdownItem tag="a" href="#">
                        Courses
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </div>
              </Dropdown>
            </div> */}
          </div>
          <div className="d-flex">
            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="fa fa-search"></span>
              </div>
            </form>
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}
            {/* <LanguageDropdown /> */}
            <div className="dropdown d-none d-lg-inline-block">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon waves-effect"
                data-toggle="fullscreen"
              >
                <i className="mdi mdi-fullscreen font-size-24"></i>
              </button>
            </div>
            <div className="dropdown d-none d-lg-inline-block mode-toggle-wrapper">
              <button
                type="button"
                className="btn header-item noti-icon waves-effect"
                style={{
                  height: "70px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="mode-toggle">
                  <input
                    type="checkbox"
                    className="checkbox"
                    id="mode-toggle"

                    onChange={e => {
                      const newMode = e.target.checked ? "dark" : "light"
                      localStorage.setItem("theme-mode", newMode)
                      props.changeMode(newMode)
                      document.body.setAttribute("data-theme-mode", newMode)
                    }}
                  />
                  <label className="label" htmlFor="mode-toggle">
                    <i className="ion ion-md-moon"></i>
                    <i className="ion ion-ios-sunny"></i>
                    <div className="ball"></div>
                  </label>
                </div>
              </button>
            </div>
            <NotificationDropdown />
            <ProfileMenu />
            {/* <div
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar)
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-spin mdi-cog"></i>
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  changeMode,
})(withTranslation()(Header))
